module.exports = __webpack_public_path__ + "static/media/styles.5e1802de.scss";